export default "__VITE_ASSET__e0406d78__"